import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Placeholder from './Placeholder';

class PlaceholderGenerator extends Component {
  constructor(props) {
    super(props);
    this.state = {
      sortedPlaceholders: this.sortPlaceholders(props.placeholders)
    };
  }
  componentDidMount() {
    // Rehydrate the Django-CMS tooltip data if we are in edit mode
    if (typeof window.CMS !== 'undefined') {
      for (let p of window.CMS._plugins) {
        if (p[1].type === 'placeholder') {
          window.CMS.$('.' + p[0]).data('cms', p[1]);
        } else {
          window.CMS.$('.' + p[0]).data('cms', [p[1]]);
        }
      }
    }
  }
  sortPlaceholders(placeholders) {
    let output = [];
    for (let placeholder of placeholders) {
      let pluginsById = {},
        pluginChildrenById = {},
        sortedPlugins = [];

      for (let plugin of placeholder.plugins) {
        pluginsById[plugin.id] = plugin;
        if (plugin.parent !== null) {
          if (plugin.parent.id in pluginChildrenById) {
            pluginChildrenById[plugin.parent.id].push(plugin.id);
          } else {
            pluginChildrenById[plugin.parent.id] = [plugin.id];
          }
        }
      }

      const sortByPosition = (a, b) => a.position - b.position;
      const addChildren = plugin => {
        if (!(plugin.id in pluginChildrenById)) {
          return plugin;
        }
        return Object.assign({}, plugin, {
          children: pluginChildrenById[plugin.id]
            .map(x => addChildren(pluginsById[x]))
            .sort(sortByPosition)
        });
      };

      for (let plugin of placeholder.plugins) {
        if (plugin.parent === null || plugin.parent.id === null) {
          let pluginWithChildren = addChildren(plugin);
          sortedPlugins.push(pluginWithChildren);
        }
      }

      sortedPlugins.sort(sortByPosition);

      output.push(Object.assign({}, placeholder, { plugins: sortedPlugins }));
    }
    return output;
  }
  componentDidUpdate(prevProps) {
    if (prevProps.placeholders !== this.props.placeholders) {
      this.setState({
        sortedPlaceholders: this.sortPlaceholders(this.props.placeholders)
      });
    }
  }
  render() {
    return (
      <div>
        {this.state.sortedPlaceholders &&
          this.state.sortedPlaceholders.map(p => (
            <Placeholder
              placeholderId={p.id}
              admin={this.props.admin}
              key={p.slot}
              slot={p.slot}
              plugins={p.plugins}
              components={this.props.components}
            >
              {p.children}
            </Placeholder>
          ))}
      </div>
    );
  }
}

PlaceholderGenerator.propTypes = {
  placeholders: PropTypes.arrayOf(PropTypes.object),
  admin: PropTypes.bool,
  components: PropTypes.object.isRequired
};

export default PlaceholderGenerator;
